import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { BarChart3 } from "lucide-react";

const slug = (s) => s.replace(/\s+/g, "-").toLowerCase();

export const LtPipeline = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/live-transfers/pipeline").then((r) => setData(r.data)).catch((e) => toast.error(apiError(e))); }, []);
  if (!data) return null;
  const cols = [...data.stages, "Returned", "total"];
  const sum = (c) => data.rows.reduce((a, r) => a + (r[c] || 0), 0);
  return (
    <Card className="mb-5 p-6" data-testid="lt-pipeline-card">
      <h3 className="mb-1 flex items-center gap-2 font-display text-lg font-bold text-slate-900"><BarChart3 className="h-5 w-5" />Live transfer pipeline</h3>
      <p className="mb-3 text-sm text-slate-600">How many live transfers each loan officer has at each stage. Returned = sent back to the Marketplace after a week.</p>
      {!data.rows.length ? <p className="text-sm text-slate-500" data-testid="lt-pipeline-empty">No live transfers assigned to loan officers yet.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[720px] text-sm" data-testid="lt-pipeline-table">
            <thead><tr className="text-left text-xs uppercase text-slate-500">
              <th className="py-2 pr-3">Loan officer</th>{cols.map((c) => <th key={c} className="px-2 py-2 text-right">{c === "total" ? "Total" : c}</th>)}
            </tr></thead>
            <tbody>
              {data.rows.map((r) => (
                <tr key={r.mlo_id} className="border-t border-slate-100" data-testid={`lt-pipeline-row-${r.mlo_id}`}>
                  <td className="py-2 pr-3 font-medium text-slate-900">{r.name}</td>
                  {cols.map((c) => <td key={c} className={`px-2 py-2 text-right tabular-nums ${r[c] ? "text-slate-900" : "text-slate-300"}`} data-testid={`lt-pipeline-${r.mlo_id}-${slug(c)}`}>{r[c]}</td>)}
                </tr>
              ))}
              <tr className="border-t-2 border-slate-200 font-semibold" data-testid="lt-pipeline-totals">
                <td className="py-2 pr-3">All loan officers</td>{cols.map((c) => <td key={c} className="px-2 py-2 text-right tabular-nums">{sum(c)}</td>)}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
};
